"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTipTitleProperty = exports.tipTitlePropertyDefinition = void 0;
exports.tipTitlePropertyDefinition = {
    view: {
        label: 'Tip Title',
        style: 'h3',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 72,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'tip-title',
};
const isTipTitleProperty = (prop) => {
    return prop.name === exports.tipTitlePropertyDefinition.name;
};
exports.isTipTitleProperty = isTipTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwLXRpdGxlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdGlwLXRpdGxlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFdBQVc7UUFDbEIsS0FBSyxFQUFFLElBQUk7S0FDWjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEVBQUU7U0FDYjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxXQUFXO0NBQ2MsQ0FBQTtBQUkxQixNQUFNLGtCQUFrQixHQUFHLENBQUMsSUFBa0IsRUFBNEIsRUFBRTtJQUNqRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssa0NBQTBCLENBQUMsSUFBSSxDQUFBO0FBQ3RELENBQUMsQ0FBQTtBQUZZLFFBQUEsa0JBQWtCLHNCQUU5QiJ9